import LongLinkExample1 from "../../../../content/posts/break-up-long-links/LongLinkExample1";
import LongLinkExample2 from "../../../../content/posts/break-up-long-links/LongLinkExample2";
import * as React from 'react';
export default {
  LongLinkExample1,
  LongLinkExample2,
  React
};